let Constants = {
  Root: "/",
  Login: "/login",
  Register: "/register",
  Explore: "/explore",
  Problems: "/Problems/:title/:id",
};
export default Constants;
